<template>
  <div>
    <pop-daren-num ref="popDarenNumRef"></pop-daren-num>
    <pop-distribute-goods-num ref="popDistributeGoodsNumRef"></pop-distribute-goods-num>
    <pop-settled-commission ref="popSettledCommissionRef"></pop-settled-commission>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item prop="searchContent">
          <el-input
              style="width:300px"
              :maxlength="50"
              v-model="searchForm.searchContent"
              placeholder="推广者名称"
          />
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-date-picker-->
<!--              v-model="searchForm.timeArr"-->
<!--              format="yyyy-MM-dd"-->
<!--              value-format="yyyy-MM-dd HH:mm:ss"-->
<!--              type="daterange"-->
<!--              range-separator="-"-->
<!--              start-placeholder="注册开始日期"-->
<!--              end-placeholder="注册结束日期"-->
<!--              :default-time="['00:00:00', '23:59:59']"-->
<!--          >-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column prop="id" label="ID" width="230"/>
      <el-table-column prop="nickname" width="230" label="推广者名称" />
      <el-table-column prop="mobile" label="注册手机号" width="180" />
      <el-table-column prop="darenNum" label="关联达人数" width="150">
        <template slot-scope="scope">
          <el-link v-if="scope.row.darenNum" type="text" @click="handleDarenNum(scope.row)">
            {{scope.row.darenNum }}
          </el-link>
          <div v-else>
            {{scope.row.darenNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="distributeGoodsNum" label="推广商品数">
        <template slot-scope="scope">
<!--          <el-link v-if="scope.row.distributeGoodsNum" type="text" @click="handleDistributeGoodsNum(scope.row)">-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </el-link>-->
<!--          <div v-else>-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </div>-->
          {{scope.row.distributeGoodsNum }}
        </template>
      </el-table-column>
      <el-table-column prop="settledCommissionBd" label="团长服务费">
        <template slot-scope="scope">
          <el-link v-if="scope.row.settledCommissionBd" type="text" @click="handleSettledCommission(scope.row)">
            {{scope.row.settledCommissionBd }}
          </el-link>
          <div @click="handleSettledCommission(scope.row)" v-else>
            {{scope.row.settledCommissionBd }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="registerTime" label="注册时间" width="180" />
      <el-table-column label="操作" width="120" align="left">
        <template slot-scope="{row}">
          <el-link type="text" @click="handleManage(row)">
            <i class="el-icon-setting"></i> 佣金设置
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>
    <group-commission-pop ref="groupCommissionPopRef" @refresh="handleRefresh"></group-commission-pop>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import manageDetailPop from './manageDetailPop.vue';
import GroupSettingPop from "./groupSettingPop.vue";
import ContactInfo from "./contactInfo.vue";
import poi from "@/api/poi";
import PopDarenNum from "./popDarenNum.vue";
import PopDistributeGoodsNum from "./popDistributeGoodsNum.vue";
import PopSettledCommission from "./popSettledCommission.vue";
import {goExportCenter} from "../../../../../utils/tool";
const PoiModel = new poi();
export default {
  name: "manageList",
  components: {
    PopSettledCommission,
    PopDistributeGoodsNum,
    PopDarenNum,
    GroupCommissionPop: GroupSettingPop,
    manageDetailPop,
    ContactInfo
  },
  data() {
    return {
      searchForm: {
        searchContent: '',
        timeArr: null
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      exportLoading: false
    }
  },
  created() {
    this.getList();
  },
  methods:{
    handleSettledCommission(row){
      this.$refs.popSettledCommissionRef.open({
        userUUID: row.userUUID
      })
    },
    handleDistributeGoodsNum(row){
      this.$refs.popDistributeGoodsNumRef.open({
        userUUID: row.userUUID
      })
    },
    handleDarenNum(row){
      this.$refs.popDarenNumRef.open({
        userUUID: row.userUUID
      })
    },
    handleRefresh() {
      this.reset()
      this.getList();
    },
    async handleManage(row){
      this.$refs.groupCommissionPopRef.open(row)
    },
    getParams(){
      const params = {
        ...this.searchForm
      }
      params.timeStart = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.timeEnd = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getAgentSearch({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      this.exportLoading = true;
      const res = await PoiModel.exportAgentSearch({
        ...this.getParams(),
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;
      await goExportCenter()
    }
  },
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/groupList.vue